import { useParams } from "react-router-dom";
import technicalObjectivesService from "./technicalObjectivesService";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { message } from "antd";

const useTechnicalObjectives = () => {
  const { trainingId } = useParams();
  const {
    setValue,
    getValues,
  } = useForm();

  const { data, isFetching, error } = useQuery(
    ["technicalObjectives", trainingId],
    () => technicalObjectivesService.getObjectivesAndUsers(trainingId),
    {
      onSuccess: (result) => {
        result.data.objectives.forEach((objective) => 
          objective.objectiveEvaluationScores.forEach((objectiveEvaluationScore) => {
            setValue(`${objectiveEvaluationScore.objectiveId}-${objectiveEvaluationScore.userId}`, objectiveEvaluationScore);
          })
        );
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const submitObjectiveEvaluationsMutation = useMutation(
    async (data) => {
      const dataToSubmit = Object.values(data).map((objEval) => {
        return {
          ...objEval,
          trainingId,
        }
      })
      try {
        await technicalObjectivesService.submitObjectivesEvaluationsScores(dataToSubmit);
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    },
    {
      onSuccess: () => {
        message.success('Your evaluation has been submitted successfully')
      },
      onError: () => {
        message.error('An error has occurred');
      },
    }
  );

  const submitObjectives = () => {
    const dataToSubmit = getValues();
    submitObjectiveEvaluationsMutation.mutate(dataToSubmit);
  }
  
  return {
    data: data?.data,
    isFetching,
    error,
    submitObjectives,
    setValue,
    getValues,
  };
};

export default useTechnicalObjectives;
